export default __webpack_public_path__ + "static/media/rnr-sports-table-2.f1350c22.webp";